import {lookupSectors} from '../../../constants/url';
import axios from 'axios';

async function useLoadLookupSectors({token, cwid, role}: any) {
  try {
    const response = await axios.get(
      `${lookupSectors}?role=${role}&cwid=${cwid}`,
      {
        headers: {Authorization: `Bearer ${token}`},
      },
    );
    return response.data;
  } catch (e) {
    console.error(e); //Que hacemos con el error?
  }
}

export default useLoadLookupSectors;
